import { render, staticRenderFns } from "./AdminSetting.vue?vue&type=template&id=61f42d5b&scoped=true"
import script from "./AdminSetting.vue?vue&type=script&lang=js"
export * from "./AdminSetting.vue?vue&type=script&lang=js"
import style0 from "./AdminSetting.vue?vue&type=style&index=0&id=61f42d5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f42d5b",
  null
  
)

export default component.exports